import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="32"
    height="29"
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.3333 10.875H20V3.625H12V10.875H6.66668L16 20.5417L25.3333 10.875ZM5.33334 22.9583H26.6667V25.375H5.33334V22.9583Z"
      fill="#81BC00"
    />
  </svg>,
  "DownloadPDFIcon"
);
